
export const Footer = () => {
   return(
    <div className="footer">
        <h2>Designed by Thanigai Solutions</h2>
    </div>
   )

}